/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Is_FurnishedInputs */

const cs_form_is_furnished = /** @type {(inputs: Form_Is_FurnishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zařízeno`)
};

const en_form_is_furnished = /** @type {(inputs: Form_Is_FurnishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Furnished`)
};

/**
* | output |
* | --- |
* | "Furnished" |
*
* @param {Form_Is_FurnishedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_is_furnished = /** @type {((inputs?: Form_Is_FurnishedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Is_FurnishedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_is_furnished(inputs)
	return cs_form_is_furnished(inputs)
});